import { type ChartDataPoint, calculateYAxisDomain } from "@roman/shared/features/chart";
import { YAxis } from "recharts";

interface CreateYAxisProps {
  chartData: ChartDataPoint[];
  selectedChoiceIds: string[];
}

/**
 * YAxisコンポーネントを生成する関数
 * ChartTooltipと同様のパターンでRechartsの制約を回避
 * Y軸のドメイン計算も内部で行う
 */
export const createYAxis = ({ chartData, selectedChoiceIds }: CreateYAxisProps) => {
  const yAxisDomain = calculateYAxisDomain(chartData, selectedChoiceIds);

  return (
    <YAxis
      stroke="#888888"
      fontSize={12}
      tickLine={false}
      axisLine={false}
      tickFormatter={(value) => `${value}%`}
      orientation="right"
      domain={yAxisDomain}
      ticks={yAxisDomain[1] <= 50 ? [0, 10, 20, 30, 40, 50] : [0, 25, 50, 75, 100]}
    />
  );
};
